import { render } from "./TempDeliveryAddressHandler.vue?vue&type=template&id=7b125800"
import script from "./TempDeliveryAddressHandler.vue?vue&type=script&lang=js"
export * from "./TempDeliveryAddressHandler.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/app/components/TempDeliveryAddressHandler.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b125800"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b125800', __exports__)) {
    api.reload('7b125800', __exports__)
  }
  
  module.hot.accept("./TempDeliveryAddressHandler.vue?vue&type=template&id=7b125800", () => {
    api.rerender('7b125800', render)
  })

}


export default __exports__